import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-nicht-ok-erfassen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeNichtOkErfassenEffects {

    AufgabeNichtOkErfassen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_NICHT_OK_ERFASSEN),
        mergeMap((x: ac.PostAufgabeNichtOkErfassenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeNichtOkErfassen(x.aufgabeFehlerbeschreibungRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeNichtOkErfassenErfolgreichAction(result, x.aufgabeFehlerbeschreibungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeNichtOkErfassenFehlerAction(error, x.aufgabeFehlerbeschreibungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
